import ACTION_TYPES from '../actions/actionTypes'

export default (state, action) => {
    switch (action.type) {
        case ACTION_TYPES.FETCH_CALENDAR_UPCOMING_EVENT:
            return {
                ...state,
                calendarUpcomingEventInfo: action.payload
            };
        default:
            return state;
    }
};